module.exports = __webpack_public_path__ + "static/media/logocreation.812f1236.png";